export default {
  fundDetail: '資金明細',
  tradeStartDate: '取引開始日',
  tradeEndDate: '取引終了日',
  tradeNo: '取引番号',
  recharge: 'チャージ',
  rechargeLog: 'チャージレコード',
  relationOrderNo: '関連オーダー番号',
  tradeIntro: '取引の説明',
  tradeTime: '取引時間',
  tradeType: '取引タイプ',
  amount: '金額',
  balance: '残高',
  payPack: '梱包伝票支払',
  payOrder: '受注支払',
  compensate: 'に報いる',
  deduct: '引き落とし',
  withdrawal: '返金（現金引き出し）',
  fund1: '購入済控除',
  fund2: '返品返金',
  fund3: '異常控除',
  fund4: '同梱払い',
  fund5: '倉庫保管費',
  fund6: '検品オプション料金控除',
  fund7: '請求書の支払',
  fund8: '購入返金を取り消す',
  fund9: '検品払い戻しを取り消す',
  fund10: '交換詳細検品料',
  fund11: '倉庫保管料の払い戻し',
  fund12: '倉庫保管費',
  fund13: '国際送料返金',
};
